var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamper = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 1.875,
  d: "M6.812 22.688h-1.5c-.5 0-.875-.625-1-1.375V4.563h21.125c1 0 1.874.875 1.874 1.875v.875c0 1-.75 2-1.875 2h-2.625l2.625 4.25c.125.25.625.624.875.874l1.625 1.5c.375.25.625.75.75 1.25 0 .25.125.625.25 1v3.625c0 .5-.375.875-.625.875h-.625M21.187 22.688H13.06"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 1.875,
  d: "M19.687 12.938c0 .75.374 1.374.75 1.374h5.374l-3-5.124h-2.375c-.375 0-.75.624-.75 1.374v2.376Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinejoin: "round",
  strokeWidth: 1.875,
  d: "M15.437 14.312h-5c-.25 0-.5-.375-.5-.75v-3.5c0-.5.25-.75.5-.75h5c.25 0 .5.375.5.75v3.5c0 .5-.25.75-.5.75ZM3.937 20.188H1.062v-5.625h2.875s.125 5.624 0 5.624Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.875,
  d: "M9.313 25.438c1.173 0 2.124-1.008 2.124-2.25 0-1.243-.95-2.25-2.124-2.25s-2.126 1.007-2.126 2.25c0 1.242.952 2.25 2.125 2.25M23.937 25.438c1.173 0 2.124-1.008 2.124-2.25 0-1.243-.95-2.25-2.125-2.25-1.173 0-2.125 1.007-2.125 2.25 0 1.242.952 2.25 2.125 2.25"
})));
export default SvgCamper;